export function clampPercentage(score: number | null | undefined): number {
  if (score === null || score === undefined) {
    return 0;
  }
  return Math.min(100, Math.max(0, score));
}

export function formatMatchScore(score: number | null | undefined): string {
  if (score === null || score === undefined) {
    return '--%';
  }
  return `${score}%`;
}
